import { useNavigate } from 'react-router-dom';
import SignUpForm from '../../components/sign_up_page/SignUpForm';
import { SIGN_IN_PAGE_PATH } from './SignInPage';
import { SignupFormProvider } from '../../contexts/forms/SignupFormContext';

export const SIGN_UP_PAGE_PATH = '/signup';

interface SignUpPageProps { }

const SignUpPage: React.FC<SignUpPageProps> = (_) => {
  const navigate = useNavigate();
  return (
    <SignupFormProvider>
      <SignUpForm onBackToLogin={() => navigate(SIGN_IN_PAGE_PATH)} />
    </SignupFormProvider>
  );
};

export default SignUpPage;
